import { render, staticRenderFns } from "./blog-like.vue?vue&type=template&id=a935535e&"
import script from "./blog-like.vue?vue&type=script&lang=js&"
export * from "./blog-like.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports